/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenerateFileUploadUrlCommand } from '../../models/generate-file-upload-url-command';
import { GenerateFileUploadUrlResult } from '../../models/generate-file-upload-url-result';

export interface ApiFilesGenerateUploadUrlPost$Params {
      body?: GenerateFileUploadUrlCommand
}

export function apiFilesGenerateUploadUrlPost(http: HttpClient, rootUrl: string, params?: ApiFilesGenerateUploadUrlPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateFileUploadUrlResult>> {
  const rb = new RequestBuilder(rootUrl, apiFilesGenerateUploadUrlPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenerateFileUploadUrlResult>;
    })
  );
}

apiFilesGenerateUploadUrlPost.PATH = '/api/files/generate-upload-url';
